var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"ml-3 white--text",attrs:{"small":"","icon":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',[_vm._v("help_outline")])],1),_c('HelperDialog',{model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }